/**
 * SupervisionPanel — the employee's supervision conversation, one click away: the card on the employee page that opens
 * the coaching conversation (a project conversation seeded with the employee, `EmployeeDetail.openConversation`). The
 * conversation itself renders with the shared conversation components on its own page.
 */
import { Button } from '../../../../components/ui';
import type { EmployeeView } from '../../shared';
import { Panel, PanelHeader } from './PanelHeader.js';

interface SupervisionPanelProps {
  employee: EmployeeView;
  onOpenThread?: () => void;
}

export function SupervisionPanel({ employee, onOpenThread }: SupervisionPanelProps) {
  const firstName = employee.name.split(' ')[0];
  return (
    <Panel>
      <PanelHeader
        title="Supervision conversation"
        subtitle="Coaching thread — tied to this employee"
        right={
          <Button size="sm" variant="secondary" onClick={onOpenThread} disabled={!onOpenThread}>
            Open thread
          </Button>
        }
      />
      <div className="px-4 py-6 text-xs text-muted">Open the thread to coach {firstName}.</div>
    </Panel>
  );
}
